define([
    '../Util/Check',
    '../Util/defaultValue',
    '../Util/defined'
], function (
    Check,
    defaultValue,
    defined) {
    'use strict'

    /**
     * 二元向量对象，可表示二维坐标。
     * @param {Number} x x坐标值。
     * @param {Number} y y坐标值。
     * 
     * @alias Vec2Obj
     * @constructor
     *
     */
    class Vec2Obj{
         /**
         * @description 在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "Vec2Obj"
        /**
         * @description x坐标值。
         * @type {Number}
         */
        x
        /**
         * @description y坐标值。
         * @type {Number}
         */
        y
        
        constructor(x, y) {
            this.x = defaultValue(x, 0.0)
            this.y = defaultValue(y, 0.0)
        }

        /**
         * 将Vec2Obj实例转换成"x y"格式的字符串。
         *
         * @returns {String} "x y"格式的字符串。
         */
        toStr(split1, split2) {
            var firstSplit = defaultValue(split1, " ")
            var secondSplit = defaultValue(split2, "")
            var result = String(this.x) + firstSplit + String(this.y) + secondSplit
            return result
        }

        /**
          * 将一定规则格式的字符串转换成Vec2Obj实例。
          *
          * @param {String} str 一定规则格式的字符串。
          * @returns {Vec2Obj} Vec2Obj实例。
          */
        static fromStrEx(str) {
            // 移除字符串开头和结尾的空白
            str = str.trim()

            // 移除末尾的任何非数字字符（如分号、逗号等）
            str = str.replace(/[^\d.-]+$/, '')

            // 用任何非数字字符（除了负号和小数点）作为分隔符来分割字符串
            const numbers = str.split(/[^\d.-]+/).filter(Boolean).map(num => parseFloat(num))

            // 检查是否正好有二个数字
            if (numbers.length !== 2 || numbers.some(isNaN)) {
                throw new Error('Invalid str: Must be exactly two numbers')
            }

            // 返回三元数组
            return new Vec2Obj(numbers[0], numbers[1])
        }
    }
    return Vec2Obj
})